export default __webpack_public_path__ + "static/media/icon_calendly.bbb8a852.svg";